export default class BaseScrollingTextReveal
{
    /**
     * @var {HTMLElement}
     */
    innerContent = null;

    /**
     * init
     * @return void
     */
    init() {
        this.innerContent = this.$refs.innerContent;

        this.$refs.reveal.style.height = this.getRevealHeight() + 'px';

        window.addEventListener("resize", () => {
            this.$refs.reveal.style.height = this.getRevealHeight() + 'px';
        });
    }

    /**
     * getRevealHeight
     * @return {number}
     */
    getRevealHeight() {
        return this.innerContent.offsetHeight + (window.innerHeight * 0.5);
    }
}


document.addEventListener("alpine:init", () => {
    Alpine.data("scrollingTextReveal", () => new BaseScrollingTextReveal());
});